import BaseService from '_services/rest/base';
import SessionService from '_services/common/sessionService';

/* eslint-disable new-parens */
class UserService extends BaseService {
  // RULES for validation
  static get ADDRESS_RULES() {
    return {
      address: 'required',
      zipcode: 'required|numeric',
      city: 'required',
    };
  }

  static get PASSWORD_RULES() {
    return {
      password: 'required',
      password_confirmation: 'required|same:password',
    };
  }

  static get PROFILE_RULES() {
    return {
      name: 'required',
      phone: 'required|numeric',
      store_activated: 'required|boolean',
    };
  }

  static get USER_RULES() {
    return {
      name: 'required',
      username: 'required',
      email: 'required|email',
    };
  }

  // ATTRIBUTES NAME for validation
  static get PASSWORD_NAMES() {
    return {
      password_new: 'new password',
      password_confirmation: 'password confirmation',
    };
  }

  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/user`;
  }

  getUrlUserCustomers() {
    return `${super.getUrl()}api/user-customers`;
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
      };
    }
    return {
      url: `${this.getUrl()}`,
    };
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUserById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteUser(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  setUserLocalStorage() {
    return this.request(this.getUrl())
      .then(result => {
        const { data: user } = result;
        SessionService.setLocalData('_user', user);

        return user;
      })
      .catch(error => {
        throw this.error(error);
      });
  }

  setCookie(expires, user) {
    SessionService.setCookie('_id', user.id, expires);
  }

  save(user) {
    let formData = new FormData();
    formData = this.setFormData(user, formData);
    const meta = this.getUrlSave(user.id);
    return this.request(meta.url, formData, 'POST')
      .catch(err => {
        throw err;
      });
  }

  // Customer users
  saveUserCustomer(ids) {
    const formData = new FormData();
    formData.append('user_id', ids.user_id);
    formData.append('customer_id', ids.customer_id);
    return this.request(`${this.getUrlUserCustomers()}/`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  listUserCustomers(userId) {
    return this.request(`${this.getUrlUserCustomers()}/${userId}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteUserCustomer(ids) {
    return this.request(`${this.getUrlUserCustomers()}/${ids.user_id}/${ids.customer_id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }
}

export default new UserService();
